export enum EnumModalType {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  DELETE = 'DELETE',
}

export enum EnumModalIcons {
  Check = 'Check',
  Warning = 'Warning',
  Trash = 'Trash',
}

export enum EnumModalInputType {
  TEXT = 'text',
  EMAIL = 'email',
  TEXT_AREA = 'text-area',
}
